import { Routes } from '@angular/router';

export const MEASUREMENTTYPE_ROUTES: Routes = [
  {
    path: 'channels/measurement-types/view-edit/:measurementTypeId',
    loadComponent: () =>
      import('./measurement-type-view-edit/measurement-type-view-edit.component').then(
        (com) => com.MeasurementTypeViewEditComponent
      ),
    title: 'View/Edit Measurement Type',
  },
  {
    path: 'channels/measurement-types/add',
    loadComponent: () =>
      import('./measurement-type-add/measurement-type-add.component').then(
        (com) => com.MeasurementTypeAddComponent
      ),
    title: 'Add Measurement Type',
  },
];
